import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import type { GetItem } from "@mnk/shared/models/item";
import type { Office } from "@mnk/shared/models/office";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import { useState } from "react";
import { BreadCrumb } from "./BreadCrumb";
import { ItemCardView } from "./CardView";
import { ItemListView } from "./ListView";
import { NewFolderModal } from "./NewFolderModal";
import { NewProjectModal } from "./NewProjectModal";

interface Props {
  items: GetItem[];
  pathItems: GetItem[];
  office: Office;
  parentId?: string;
  afterCreateItem: () => void;
  mutateItems: () => Promise<void>;
}

export const ItemList = ({ items, pathItems, office, parentId, afterCreateItem, mutateItems }: Props) => {
  const [view, setView] = useState<"list" | "card">("list");
  const [isNewFolderModalOpen, setIsNewFolderModalOpen] = useState(false);
  const [isNewProjectModalOpen, setIsNewProjectModalOpen] = useState(false);

  return (
    <div className="w-full max-w-4xl mx-auto">
      <BreadCrumb office={office} pathItems={pathItems} />
      <div className="flex items-center justify-between p-4 border-b border-gray-200 mb-4">
        <p className="text-xl font-bold">一覧</p>
        <div className="flex items-center gap-2">
          <PrimaryButton className="text-xs" type="button" onClick={() => setIsNewProjectModalOpen(true)}>
            プロジェクト作成
          </PrimaryButton>
          <PrimaryButton className="text-xs" type="button" onClick={() => setIsNewFolderModalOpen(true)}>
            フォルダ作成
          </PrimaryButton>
          <ListIcon
            className={`cursor-pointer text-gray-800 ${view === "list" ? "fill-blue-500" : ""}`}
            onClick={() => setView("list")}
          />
          <GridViewIcon
            className={`cursor-pointer text-gray-800 ${view === "card" ? "fill-blue-500" : ""}`}
            onClick={() => setView("card")}
          />
        </div>
      </div>

      {view === "list" ? (
        <ItemListView
          items={items}
          setIsNewFolderModalOpen={setIsNewFolderModalOpen}
          setIsNewProjectModalOpen={setIsNewProjectModalOpen}
          mutateItems={mutateItems}
        />
      ) : (
        <ItemCardView
          items={items}
          setIsNewFolderModalOpen={setIsNewFolderModalOpen}
          setIsNewProjectModalOpen={setIsNewProjectModalOpen}
          mutateItems={mutateItems}
        />
      )}

      {isNewFolderModalOpen && (
        <NewFolderModal
          parentId={parentId}
          afterCreateItem={afterCreateItem}
          onClose={() => setIsNewFolderModalOpen(false)}
          officeId={office.id}
        />
      )}
      {isNewProjectModalOpen && (
        <NewProjectModal
          parentId={parentId}
          afterCreateItem={afterCreateItem}
          onClose={() => setIsNewProjectModalOpen(false)}
          officeId={office.id}
        />
      )}
    </div>
  );
};
